// Dependencies

import React, { Component } from 'react';

// Images

import facebookIcon from '../images/facebook.svg';
import instagramIcon from '../images/instagram.svg';
import googleIcon from '../images/google-plus.svg';

// Style

import './SocialMedia.css';

const SocialMedia = () => (
  <div className="social-media">
    <a href="https://www.facebook.com/hibachiandyou/"><img alt="Facebook" className="social-media__icon" src={facebookIcon} /></a>
    <a href="https://www.instagram.com/hibachiandyou/"><img alt="Instagram" href="" className="social-media__icon" src={instagramIcon} /></a>
    <a href="https://plus.google.com/106436304534122980961"><img alt="Google" className="social-media__icon" src={googleIcon} /></a>
  </div>
);

export default SocialMedia;



// WEBPACK FOOTER //
// ./src/SocialMedia/SocialMedia.js